import useRecorder from "./useRecorder";
import clsx from 'clsx';

import MicImg from "./img/microphone.png";
import MicMuteImg from "./img/microphone-slash.png";

import './recorder.css';

const Recorder = ({
  currentPageName,
  setTranscription,
  chapterComplete,
  chapterStart,
  disableBtn,
  isMenuRetract,
}) => {
  const {
    toggleMic,
    isRecording,
    isButtonDisabled,
  } = useRecorder({
    setTranscription,
    chapterComplete,
    chapterStart,
    currentPageName,
  });

  console.log('>>> currentPageName', currentPageName)
  
  return (
    <>
      <button
        disabled={disableBtn || isButtonDisabled}
        className={clsx('recorder', {
          'recorder--start': !isRecording,
          'recorder--stop': isRecording,
          'recorder--show': !isMenuRetract,
        })}
        id="mic"
        onClick={toggleMic}
        aria-label={isRecording ? "Parar gravação" : "Iniciar gravação"}
      >
        {isRecording ?
          <img src={MicImg} className="mic-img" alt="" /> :
          <img src={MicMuteImg} className="mic-img" alt="" />
        }
      </button>
    </>
  )
};

export default Recorder;